import { render, staticRenderFns } from "./video.vue?vue&type=template&id=4607fc02&scoped=true&"
import script from "./video.vue?vue&type=script&lang=ts&"
export * from "./video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4607fc02",
  null
  
)

export default component.exports